import { AchRecipientModelDto } from '@treasury/api/channel';

export const includeInCreditTotal = (recipient: AchRecipientModelDto) =>
    recipient.transactionType === 'CR' && !recipient.hold;
export const includeInDebitTotal = (recipient: AchRecipientModelDto) =>
    recipient.transactionType === 'DR' && !recipient.hold;
export const reduceRecipientAmounts = (acc: number, r: AchRecipientModelDto) => acc + r.amount;
